module.exports = __webpack_public_path__ + "images/logo-xero.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-xero.svg
// module id = 1120
// module chunks = 1